const commonVal = {
    requestUrl: "http://124.222.209.62:8080",
	imgUrl: "http://124.222.209.62/atstudy-cateye/imgs"
}



module.exports = commonVal